module.exports = __webpack_public_path__ + "static/media/BookEat_logo-04.7aaf2d7a.png";